import type { CityConfig } from "../city-template/types";

export const fuquayVarinaConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Fuquay-Varina",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "fuquay-varina",
  route: "/cities/fuquay-varina",
  title: "Emergency Passport Fuquay-Varina, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Fuquay-Varina, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Wake County and southern Research Triangle. Get your passport fast with Fast Passport Center.",
  h1: "Emergency & Expedited Passport Services in Fuquay-Varina, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Fuquay-Varina and southern Wake County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Fuquay%20Varina%20North%20Carolina%20charming%20historic%20downtown%20main%20street%20at%20golden%20hour%20with%20vintage%20brick%20buildings%20and%20small%20town%20American%20atmosphere%2C%20tree-lined%20sidewalks%20with%20Southern%20charm%2C%20warm%20sunset%20light%20over%20Wake%20County%20suburban%20community%2C%20green%20trees%20and%20well-maintained%20storefronts%2C%20historic%20Varina%20district%20visible%2C%20professional%20cityscape%20photography%20with%20warm%20earthy%20tones%20and%20southern%20small%20town%20charm%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=fuquay-varina-hero-nc-001&orientation=landscape",
  heroImageAlt: "Fuquay-Varina North Carolina charming historic downtown with vintage brick buildings and tree-lined streets at golden hour",
  geoPosition: "35.5843;-78.8000",
  geoPlacename: "Fuquay-Varina, North Carolina",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 280 miles north — about 4.5 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "Fuquay-Varina", zips: "27526" },
    { name: "Holly Springs", zips: "27540" },
    { name: "Apex", zips: "27502, 27523, 27539" },
    { name: "Cary", zips: "27511, 27513, 27518, 27519" },
    { name: "Raleigh", zips: "27601–27699" },
    { name: "Durham", zips: "27701–27717" },
    { name: "Morrisville", zips: "27560" },
    { name: "Chapel Hill", zips: "27514, 27516, 27517" },
    { name: "Garner", zips: "27529" },
    { name: "Wake Forest", zips: "27587, 27588" },
    { name: "Knightdale", zips: "27545" },
    { name: "Zebulon", zips: "27597" },
    { name: "Wendell", zips: "27591" },
    { name: "Angier", zips: "27501" },
    { name: "Clayton", zips: "27520, 27527" },
    { name: "Smithfield", zips: "27577" },
    { name: "Lillington", zips: "27546" },
    { name: "Sanford", zips: "27330, 27332" },
    { name: "Fayetteville", zips: "28301–28312" },
    { name: "Wilson", zips: "27893, 27894, 27895, 27896" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent southern Wake County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Southern Wake Hub", desc: "Serving Fuquay-Varina, Holly Springs, Apex, and southern Research Triangle" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Fast passport renewal in Cary, NC", route: "/cities/cary" },
    { name: "Emergency passport help in Holly Springs, NC", route: "/cities/holly-springs" },
    { name: "Emergency passport help in Morrisville, NC", route: "/cities/morrisville" },
    { name: "Passport courier services in Garner, NC", route: "/cities/garner" },
    { name: "Urgent passport services in Apex, NC", route: "/cities/apex" },
    { name: "Same-day passport help in Durham, NC", route: "/cities/durham" },
    { name: "Passport courier services in Wake Forest, NC", route: "/cities/wake-forest" },
    { name: "Fast passport renewal in Fayetteville, NC", route: "/cities/fayetteville" },
    { name: "Passport courier services in Wilson, NC", route: "/cities/wilson" },
    { name: "Passport courier services in Sanford, NC", route: "/cities/sanford" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Fuquay-Varina remotely via secure courier. We do not have a walk-in office in Fuquay-Varina — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for southern Wake County and the Research Triangle travelers.",
  fpcOfficeAddress: "301 Fayetteville St, Raleigh, NC 27601",
  mapEmbedUrl: "https://www.google.com/maps?q=301+Fayetteville+St,+Raleigh,+NC+27601&output=embed",
  fpcOfficeDistance: "Serving all of southern Wake County and the Research Triangle metropolitan region",
  serviceAreaIntro: "From the historic downtown districts of Fuquay-Varina to the suburban neighborhoods of Holly Springs, from the growing communities of Apex and Cary to the university corridors of Raleigh and Durham, from the bustling tech hubs of Morrisville to the quiet streets of Garner and Clayton, from the military families of Fayetteville to the southern roads of Angier and Lillington — Fast Passport Center serves the entire Fuquay-Varina region. We regularly help travelers from the southern Research Triangle, Wake County, and Johnston County get their expedited passports fast.",
  nearbyCitiesIntro: "We serve all Fuquay-Varina neighborhoods and the surrounding southern Research Triangle area including Holly Springs, Apex, Cary, Raleigh, Durham, Morrisville, Chapel Hill, Garner, Wake Forest, Knightdale, Zebulon, Wendell, Angier, Clayton, Smithfield, Lillington, Sanford, Fayetteville, and Wilson. If you are anywhere in Wake County, Johnston County, Harnett County, or the southern Research Triangle, we have you covered for fast passport and expedited passport services.",
  howItWorksIntro: "Most Fuquay-Varina travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Fuquay-Varina travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays in getting an expedited passport.",
  testimonialsIntro: "Fuquay-Varina and southern Wake County travelers trust us when their departure is days away. Here is what some of them have to say about our emergency passport and fast passport services.",
  faqIntro: "Have questions about expedited passports in Fuquay-Varina? Here are the most common ones we hear from southern Wake County travelers about emergency passport and fast passport processing.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Fuquay-Varina international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Amy P.",
      location: "Fuquay-Varina, NC",
      rating: 5,
      text: "My passport expired 3 days before our cruise to the Caribbean. Fast Passport Center had my renewal ready in 26 hours. I never left Fuquay-Varina. The expedited passport service was absolutely amazing.",
      service: "Passport Renewal",
    },
    {
      name: "John R.",
      location: "Holly Springs, NC",
      rating: 5,
      text: "Emergency passport for a business trip to London. Got it in 28 hours. Fast Passport Center handled everything — I didn't have to drive to Philadelphia. Saved a major client meeting.",
      service: "Emergency Passport",
    },
    {
      name: "Maria S.",
      location: "Apex, NC",
      rating: 5,
      text: "First passport for my 11-year-old before our Europe trip. Fast Passport Center walked us through every document and had her passport in 4 days. So easy for southern Wake families.",
      service: "Child Passport",
    },
    {
      name: "Brian K.",
      location: "Cary, NC",
      rating: 5,
      text: "Lost my passport 2 days before a conference in Paris. Fast Passport Center had a replacement in my hands in 33 hours. Their Research Triangle coverage is the best for fast passport services.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "fuquay-1",
      name: "Fuquay-Varina Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "212 E Vance St",
      city: "Fuquay-Varina",
      state: "NC",
      zip: "27526",
      phone: "(919) 552-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Fuquay-Varina",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Fuquay-Varina facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "fuquay-2",
      name: "Holly Springs Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 W Buffalo St",
      city: "Holly Springs",
      state: "NC",
      zip: "27540",
      phone: "(919) 552-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles north of Fuquay-Varina",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Wake County and Holly Springs area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "fuquay-3",
      name: "Apex Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 E Williams St",
      city: "Apex",
      state: "NC",
      zip: "27502",
      phone: "(919) 362-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles north of Fuquay-Varina",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Apex and Cary area. Less crowded than Raleigh. Photo services nearby at CVS and Walgreens.",
      icon: "ri-mail-line",
    },
    {
      id: "fuquay-4",
      name: "Cary Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "315 N Academy St",
      city: "Cary",
      state: "NC",
      zip: "27513",
      phone: "(919) 467-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles north of Fuquay-Varina",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Cary and Morrisville. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "fuquay-5",
      name: "Wake County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "300 S Salisbury St",
      city: "Raleigh",
      state: "NC",
      zip: "27601",
      phone: "(919) 792-4000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "20 miles northeast of Fuquay-Varina, Courthouse",
      website: "https://www.wakegov.com/",
      websiteLabel: "Wake County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "fuquay-6",
      name: "Raleigh Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "414 E Holding Ave",
      city: "Raleigh",
      state: "NC",
      zip: "27610",
      phone: "(919) 755-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles northeast of Fuquay-Varina",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Raleigh metro. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Fuquay-Varina photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Wake County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Fuquay-Varina applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Wake County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Fuquay-Varina travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Fuquay-Varina." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Fuquay-Varina address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Fuquay-Varina before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Fuquay-Varina for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the long drive to Washington DC." },
    { q: "How fast can I get an expedited passport in Fuquay-Varina?", a: "Fast Passport Center offers expedited passport services in Fuquay-Varina in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day standard expedited option provides the best value. Both options include full document review and a dedicated agent to ensure your fast passport is processed correctly." },
    { q: "What is the closest passport agency to Fuquay-Varina?", a: "The nearest regional passport agency to Fuquay-Varina is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 280 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Fuquay-Varina without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Fuquay-Varina?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 4.5 hours from Fuquay-Varina — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for southern Wake County and Research Triangle residents." },
    { q: "Do you serve the entire southern Research Triangle area for expedited passports?", a: "Absolutely. Fast Passport Center provides expedited passport services throughout the entire southern Research Triangle metropolitan area including Fuquay-Varina, Holly Springs, Apex, Cary, Raleigh, Durham, Morrisville, Chapel Hill, Garner, Wake Forest, Knightdale, Zebulon, Wendell, Angier, Clayton, Smithfield, Lillington, Sanford, Fayetteville, and Wilson. Our courier service works seamlessly from any address in Wake County, Johnston County, Harnett County, and surrounding areas." },
    { q: "Can I expedite a child passport in Fuquay-Varina?", a: "Yes. Fast Passport Center expedites child passports in Fuquay-Varina for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk southern Wake County families through the entire fast passport process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Fuquay-Varina with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency for an expedited passport?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change. This is how we deliver fast passport and expedited passport services to Fuquay-Varina without the long drive." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Fuquay-Varina", address: "1401 E Broad St, Fuquay-Varina, NC 27526", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Fuquay-Varina", address: "1317 E Broad St, Fuquay-Varina, NC 27526", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Fuquay-Varina", address: "1050 E Broad St, Fuquay-Varina, NC 27526", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Holly Springs", address: "3200 N Main St, Holly Springs, NC 27540", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Apex", address: "1490 N Salem St, Apex, NC 27523", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Cary", address: "1010 SE Cary Pkwy, Cary, NC 27518", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Raleigh", address: "3600 New Bern Ave, Raleigh, NC 27610", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Raleigh", address: "435 S Salisbury St, Raleigh, NC 27601", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Fuquay-Varina",
      address: "1301 E Broad St, Fuquay-Varina, NC 27526",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Holly Springs",
      address: "7010 GB Alford Hwy, Holly Springs, NC 27540",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Raleigh",
      address: "3231 Avent Ferry Rd, Raleigh, NC 27606",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Raleigh and western Wake County. REAL ID available.",
      featured: true,
    },
    {
      name: "NC DMV — Cary",
      address: "1100 N Harrison Ave, Cary, NC 27513",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Cary and Morrisville area. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "20 miles northeast of Fuquay-Varina",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international airport for the Research Triangle. Direct flights to London, Paris, Cancun, Toronto, and major domestic destinations. American, Delta, and United hub. Only 30 minutes from Fuquay-Varina.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: true,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "160 miles southwest of Fuquay-Varina",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major alternative hub for the Charlotte metro area. Additional international routes.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "70 miles west of Fuquay-Varina",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for North Carolina residents. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Wake County Register of Deeds',
      description: 'Marriage licenses and records for Wake County. Apply in person or request certified copies.',
      url: 'https://www.wake.gov/departments-government/register-deeds',
    },
    {
      label: 'Wake County Clerk of Superior Court',
      description: 'Divorce records and decrees for Wake County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/wake-county/wake-county-clerk-of-superior-court',
    },
  ],
};